export default {
  // 模块名称
  area: {
    // 按钮类
    button: {
      reset: '重置',
      query: '查询',
      save: '保存',
      cancel: '取消',
      confirm: '确认',
      addarea: '新增区域',
      editarea: '编辑区域',
      delarea: '删除区域',
      close: '关闭'
    },
    // 文字标签类
    label: {
      center: '区域中心',
      code: '区域编码',
      name: '名称',
      ownerList: '区域负责人',
      workshopArea: '车间通行区域',
      parentName: '上级名称',
      longitude: '经纬度',
      latitude: '',
      remark: '备注',
      personnelCode: '人员编号',
      personnelType: '人员类型',
      personnelMark: '人员标记',
      personnelName: '人员姓名',
      sex: '性别',
      phone: '电话',
      workNo: '工号',
      departmentName: '部门名称',
      position: '岗位'
    },
    // 提示类
    placeholder: {
      name: '请输入名称',
      remark: '请输入备注',
      ownerList: '请选择区域负责人',
      longitude: '请输入经度',
      latitude: '请输入纬度'
    },
    // 消息类
    message: {
      deltips: '您确定删除该区域吗?',
      selecttips: '请先选择区域',
      delSuccess: '区域删除成功',
      addSuccess: '区域新增成功',
      editSuccess: '区域修改成功',
      nodelete: '该区域{name}下存在子级，不允许删除',
      lng: '请输入-180~180之间,小数点最大保留10位',
      nospace: '名称前后不允许存在空格',
      name: '请输入区域名称',
      ownerList: '请选择区域负责人',
      less30: '长度在 1 到 30 个字符',
      less15: '长度在 1 到 15个字符',
      lat: '请输入-90~90之间,小数点最大保留10位',
      less200: '长度在 0到 200个字符'
    },
    // 标题类
    title: {
      warn: '确认',
      add: '新增区域',
      edit: '修改区域',
      view: '查看区域'
    }
  }
}
